<template>
  <div v-if="!!row.childList">
    <Row class="expand-row"  v-for="(rowItem) in row.childList" :key="rowItem.optionId">
      <Col span="5">
        <span class="expand-value">{{ rowItem.name }}</span>
      </Col>
      <Col span="3">
        <span class="expand-value">{{ rowItem.code }}</span>
      </Col>
      <Col span="3">
        <span class="expand-value">单项</span>
      </Col>
      <Col span="3">
        <span class="expand-value">{{ row.bloodTubeName }}</span>
      </Col>
      <Col span="3">
        <span class="expand-value">{{ row.inspectOrganizeName }}</span>
      </Col>
    </Row>
  </div>
</template>
<script>
import { mixins } from "@/mixins/index.js";
export default {
  name: "LisProjectTableItem",
  mixins: [mixins],
  data() {
    return {};
  },
  props:{
    row:{
      type: Object,
      default:()=>{
        return {};
      }
    }
  },
  mounted() {
  },
  methods: {
  }
};
</script>
<style lang="postcss" scoped>
.expand-row{
  margin-bottom: 16px;
}
.expand-key{
  font-weight: 600;
}
</style>
